import { gql } from "@apollo/client";

import handleStaticProps from "src/lib/handle-static-props";

import DeejayIndexPage from "..";

export async function getStaticProps() {
  const { result } = await handleStaticProps({
    pageQuery,
    variables: { page: 1 },
  });

  return result;
}

function StaffIndexPage() {
    return <DeejayIndexPage staff query={pageQuery} />
}

export default StaffIndexPage;

const pageQuery = gql`
  query Deejays($page: Int) {
    allDeejays(page: $page, staff: true) {
      page
      pages
      edges: objects {
        __typename
        id
        pic
        dj
        url
      }
    }
  }
`;